module.exports = __webpack_public_path__ + "static/Juxtapose-Join-Our-Gym-a4d61582e08f4ce2f2b3c88ef19b4bd4.png";